<template>
  <div
    v-tooltip="{
      content: fullName,
      placement: Placement.Bottom,
      delay: { show: 300, hide: 100 },
      distance: 16,
    }"
    class="completed-by-container"
  >
    <Avatar
      :name="fullName"
      :size="AvatarSize.Small"
      :thumb-url="thumbUrl"
      :deleted-at="deletedAt"
    />
    <div class="completed-by-info">
      <FriedH4>{{ t('MAP_completed_by') }}</FriedH4>
      <FriedParagraph :size="ParagraphSize.Small">{{ fullName }}</FriedParagraph>
    </div>
  </div>
</template>
<script setup lang="ts">
import { AvatarSize, ParagraphSize, Placement } from '@getaccept/fried-tofu';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import type { Participant } from '../../types';
import Avatar from '../../components/Avatar.vue';
import AvatarHelper from '../../helpers/avatar.helper';

const props = defineProps<{
  completedBy: User | Participant;
}>();

const { t } = useI18n();

const fullName = computed(() => AvatarHelper.getDisplayName(props.completedBy));

const thumbUrl = computed(() => {
  if ('thumbUrl' in props.completedBy) {
    return props.completedBy.thumbUrl;
  }
  return '';
});

const deletedAt = computed(() =>
  'deletedAt' in props.completedBy ? props.completedBy.deletedAt : null
);
</script>
<style lang="scss" scoped>
.completed-by-container {
  display: flex;
  align-items: center;
  gap: var(--spacing-50);
  flex-shrink: 0;

  .heading-4,
  .paragraph {
    color: var(--green-25);
  }

  .paragraph {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 110px;
  }
}
</style>
